import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../../commons/services/http.service';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestAutoenrolamientoInterface } from './interface/request-autoenrolamiento-interface';
import { RequestRechazoInterface } from './interface/request-rechazo-interface';
import { RequestEnvioCorreoInterface } from './interface/request-envio-correo-interface';
import { ENV_TOKEN } from '../../../app-module.token';

@Injectable({
  providedIn: 'root',
})
export class DictaminacionService {
  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;

  private httpService: HttpService = inject(HttpService);
  readonly environment = inject(ENV_TOKEN);

  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }

  /**
   * Obtiene los datos de un autoenrolamiento, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se agrega el ID de autoenrolamiento a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
   * @param idAutoEnrolamiento 
   * @returns 
   */
  getDataAutoEnrolamiento(idAutoEnrolamiento: number): Observable<any> {
    const funcion = "icoij/AutoEnrolamiento";
    const ruta = `${this.urlRaiz}/${funcion}/${idAutoEnrolamiento}`;
    return this.httpService.getRequest(ruta);
  }

  /**
   * Envía una dictaminación positiva para un autoenrolamiento, se construye la ruta para el envío utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio
   * @param request 
   * @returns 
   */
  postDictaminacionPositiva(request: RequestAutoenrolamientoInterface) {
    const funcion = "icoij/AutoEnrolamiento";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  /**
   * Envía una dictaminación de confirmación para un autoenrolamiento, se construye la ruta para el envío utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio
   * @param request 
   * @returns 
   */
  postDictaminacionConfirma(request: RequestEnvioCorreoInterface) {
    const funcion = "icoij/AutoEnrolamiento/Confima";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  /**
   * Envía una dictaminación de rechazo para un autoenrolamiento, se construye la ruta para el envío utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio
   * @param request 
   * @returns 
   */
  postDictaminacionRechazo(request: RequestRechazoInterface) {
    const funcion = "icoij/AutoEnrolamiento/Rechazo";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

}
